import styled from "@emotion/styled/macro";
import { PropsWithChildren } from "react";
import { maxWidth } from "helpers/styleConstants";

const StyledPageWrapper = styled.div<{ hideNav: boolean }>`
  width: 100%;
  padding-left: ${(props) => (props.hideNav ? "0px" : "80px")};
  @media only screen and (max-width: ${maxWidth}px) {
    padding-left: 0px;
  }
`;

const PageWrapper = ({
  children,
  hideNav,
}: PropsWithChildren<{ hideNav: boolean }>) => {
  return <StyledPageWrapper hideNav={hideNav}>{children}</StyledPageWrapper>;
};

export { PageWrapper };
